import Autosuggest from 'react-autosuggest';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators as bind} from 'redux';
import { connect } from 'react-redux';
import { getMerchants } from '../../../api/merchantAutocompleteUtils';
import { theme } from './AutocompleteTheme';
import debounce from 'lodash.debounce'

export class Autocomplete extends React.Component {
  constructor() {
    super();

    this.state = {
      value: '',
      suggestions: [],
    };
  }

  getSuggestionValue = suggestion => suggestion

  renderSuggestion = suggestion => (
    <div>
      {suggestion}
    </div>
  );

  onChange = (event, {newValue}) => {
    this.setState({
      value: newValue
    });
    this.props.onChange(newValue)
  };

  filterSuggestion = (unFilteredSuggestion, inputValue) => {
    const regex = new RegExp("^" + inputValue, "i");

    return unFilteredSuggestion.map((x) => {
      if(x[0] != null && regex.test(x[0])) {
        return x[0];
      } else {
        return x[1];
      }
    });
  }
  
  fetchSuggestions = debounce(({ value }) => {
    var merchants = getMerchants(value);
    merchants.then((result) => {
      var filteredResult = this.filterSuggestion(result, value)
      this.setState({
        suggestions: filteredResult
      })
    });
  }, 250)

  // Autosuggest will call this function every time you need to update suggestions.
  onSuggestionsFetchRequested = (options) => {
    this.fetchSuggestions(options)

    if (process.env.NODE_ENV === 'test') {
      this.fetchSuggestions.flush()
    }
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onSuggestionSelected = (event, { suggestionValue }) => {
    this.setState({value: suggestionValue}, () => {
      this.props.search()
    });
    this.props.onChange(suggestionValue)
  }

  clear = () => {
    var emptyValue = '';
    this.props.onChange(emptyValue)
    this.setState({value: emptyValue}, () => {
      this.props.search()
    });
  };


  render() {
    const { value, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: 'Search by Merchant DBA or Legal Name',
      value: this.state.value,
      onChange: this.onChange.bind(this),
    };

    // Finally, render it!
    return (
      <form className="autocomplete searchbar" onSubmit={e => {e.preventDefault(); this.props.search(this.state.value);}} >
        <div className="input-container">
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            inputProps={inputProps}
            theme={theme}
            onSuggestionSelected={this.onSuggestionSelected}
          />
          <i className="icon icon-close" onClick={this.clear} />
        </div>
        <button type="submit"><i className="icon icon-magnifier" /></button>
      </form>
    );
  }
}

Autocomplete.propTypes = {
  fetchMerchantItems: PropTypes.func,
  search: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

export default Autocomplete;
